<template>
    <template v-if="!loading && !error && found > 0">
        <div class="container-fluid item-lists-type-1">
            <div class="container">
                <AccountsListItem
                    v-for="account in displayedAccounts"
                    :key="account.account_id"
                    :account="account"
                />
                <AccountsListItemCreate v-if="isProspectPro && showCta" />
            </div>
        </div>
        <PaginationPanel
            :pagination="pagination"
            :total="total"
            @update-pagination="handlePaginationUpdate"
        />
    </template>

    <NoResultsSection
        v-else-if="!loading && !error"
        :message="options.search ? 'views.accounts.no_results_search' : ''"
        :translationPlaceholders="options.search ? { query: `<span>${options.search}</span>` } : {}"
    />
    <ErrorSection v-else-if="error" :error="error" />
    <LoadingSection v-else />
</template>

<script>
    import { mapState, mapActions } from 'pinia';
    import { useAccountsStore } from '@/stores/accounts';
    import { useProductsStore } from '@/stores/products';
    import AccountsListItem from '@/components/accounts/AccountsListItem.vue';
    import AccountsListItemCreate from '@/components/accounts/AccountsListItemCreate.vue';
    import ErrorSection from '@/components/sections/ErrorSection';
    import LoadingSection from '@/components/sections/LoadingSection';
    import NoResultsSection from '@/components/sections/NoResultsSection';
    import PaginationPanel from '@/components/panels/pagination/PaginationPanel';
    import { scrollToTop } from '@/utils/scroll';

    export default {
        name: 'AccountsList',
        components: {
            AccountsListItem,
            AccountsListItemCreate,
            ErrorSection,
            LoadingSection,
            NoResultsSection,
            PaginationPanel
        },
        data() {
            return {
                displayedAccounts: []
            };
        },
        computed: {
            ...mapState(useAccountsStore, ['accounts', 'loading', 'error', 'found', 'options', 'pagination', 'total', 'updatingOptions', 'hasDefaultOptions']),
            showCta() {
                return this.found <= 4 && this.updatingOptions === false && !!this.hasDefaultOptions;
            },
            isProspectPro() {
                return process.env.VUE_APP_TYPE === 'bedrijfsdata';
            }
        },
        methods: {
            ...mapActions(useAccountsStore, ['loadAccounts', 'updatePagination']),
            handlePaginationUpdate(newPagination) {
                this.updatePagination(newPagination);
            }
        },
        created() {
            this.loadAccounts();
            useProductsStore().getProducts();
        },
        watch: {
            accounts: {
                handler(newAccounts) {
                    scrollToTop();
                    this.displayedAccounts = [];
                    newAccounts.forEach((account, index) => {
                        setTimeout(() => {
                            this.displayedAccounts.push(account);
                        }, index * 50 < 500 ? index * 50 : 500);
                    });
                },
                deep: true
            }
        },
    };
</script>
